"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactSortableHoc = require("react-sortable-hoc");

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _dropZone = _interopRequireDefault(require("../../../dropZone"));

var _locationManager = require("../../../../../redux/locationManager");

var _btnRemovePhoto = _interopRequireDefault(require("../../../../../img/btn-remove-photo.svg"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SortableItem = (0, _reactSortableHoc.SortableElement)(function (_ref) {
  var value = _ref.value,
      onDeleteClick = _ref.onDeleteClick,
      itemIndex = _ref.itemIndex;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: "relative"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: "absolute",
      top: "0px",
      right: "10px"
    }
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    tooltip: "Remove",
    onClick: function onClick() {
      onDeleteClick(itemIndex);
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _btnRemovePhoto.default,
    alt: "remove button",
    style: {
      pointerEvents: 'none'
    }
  }))), /*#__PURE__*/_react.default.createElement("img", {
    className: "location-details-image-preview",
    src: value,
    alt: "location edit preview"
  }));
});
var SortableList = (0, _reactSortableHoc.SortableContainer)(function (_ref2) {
  var items = _ref2.items,
      onDeleteClick = _ref2.onDeleteClick;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex"
  }, items.map(function (value, index) {
    return /*#__PURE__*/_react.default.createElement(SortableItem, {
      key: "item-".concat(value),
      itemIndex: index,
      index: index,
      value: value,
      onDeleteClick: onDeleteClick
    });
  }));
});

var ImageUpload = function ImageUpload(_ref3) {
  var photos = _ref3.photos,
      handleChange = _ref3.handleChange;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      uploading = _useState2[0],
      setUploading = _useState2[1];

  var dispatch = (0, _reactRedux.useDispatch)();

  var handlePhotosChange = function handlePhotosChange(newPhotos) {
    handleChange({
      target: {
        name: "photos",
        value: newPhotos
      }
    });
  };

  var onUpload = function onUpload(files) {
    setUploading(true);
    dispatch((0, _locationManager.uploadFile)(files[0], setUploading, photos, handlePhotosChange));
  };

  var onSortEnd = function onSortEnd(info, event) {
    var newPhotos = (0, _reactSortableHoc.arrayMove)(photos, info.oldIndex, info.newIndex);
    handlePhotosChange(newPhotos);
  };

  var onDeleteClick = function onDeleteClick(index) {
    console.log("onDeleteClick", index);

    var newPhotos = _toConsumableArray(photos);

    newPhotos.splice(index, 1);
    handlePhotosChange(newPhotos);
  };

  var shouldCancelStart = function shouldCancelStart(event) {
    console.log("shouldCancelStart", event.target.className);
    return Boolean(event.target.className.match(/MuiIconButton-label|MuiIconButton-root/));
  };

  if (photos) {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_dropZone.default, {
      outline: true,
      accepts: ".jpg,.jpeg,.png,.gif",
      loading: uploading,
      onDrop: onUpload
    }), /*#__PURE__*/_react.default.createElement(SortableList, {
      items: photos,
      axis: "x",
      onSortEnd: onSortEnd,
      onDeleteClick: onDeleteClick,
      shouldCancelStart: shouldCancelStart
    }));
  }

  return /*#__PURE__*/_react.default.createElement("div", null);
};

var _default = ImageUpload;
exports.default = _default;